/**
 * シンプルなPopup管理
 *
 * fancyboxではchrome操作の場合にスクロールバーをマウスホイールで操作することで
 * DOMがずれる不具合があるためこのクラスが必要
 */
var simple_popup_service = {
  conf: {
    default_open_speed: 250
    , default_close_speed: 250
    , use_fancybox: false
    //, use_fancybox: true  //fancyboxの動きの確認用。通常はfalse
  }
  , id: {
    background: 'simple_popup_service_background'
    , container: 'simple_popup_service_container'
    , box: 'simple_popup_service_box'
    , scroll: 'simple_popup_service_scroll'
    , keep: 'simple_popup_service_keep'
  }
  
  , val: {
    option: null
    , now_opening: false
    , now_closing: false
    , is_open: false
    , is_init: false
    , space_display: null
  }
  
  //各オブジェクトの取得
  
  //背景のオブジェクト
  , popup_background_obj: function () {
    return $('#' + this.id.background);
  }
  //コンテナのオブジェクト
  , popup_container_obj: function () {
    return $('#' + this.id.container);
  }
  //ボックス部分のオブジェクト
  , popup_box_obj: function () {
    return $('#' + this.id.box);
  }
  //スクロール部分のオブジェクト
  , popup_scroll_obj: function () {
    if (this.conf.use_fancybox) {
      console.log('fancybox test scroll_obj');
      return $(".fancybox-inner");
    }
    
    return $('#' + this.id.scroll);
  }
  //ターゲットスペースのオブジェクト
  , popup_space_obj: function () {
    return $(this.val.option.href);
  }
  
  //目印部分のオブジェクト
  , popup_keep_obj: function () {
    return $('#' + this.id.keep);
  }
  
  //初期化
  
  //初期化されているか確認して、初期化されていない場合は初期化する
  , check_init: function () {
    if ( ! this.val.is_init) {
      var self = this;
      
      $(window).resize(function() {
        if (self.val.is_open) {
          self.resize();
        }
      });
      
      //入れ物を設置
      $('body').append(
        '<div id="' + this.id.background + '" class="simple_popup_service_background">' +
          '<div id="' + this.id.container + '" class="simple_popup_service_container" onclick="simple_popup_service.onclick_container(event);">' + 
            '<div id="' + this.id.box + '" class="simple_popup_service_box">' + 
              '<div id="' + this.id.scroll + '" class="simple_popup_service_scroll">' + 
              '</div>' + 
              '<div class="simple_popup_service_close" onclick="simple_popup_service.close();"></div>' + 
            '</div>' + 
          '</div>' + 
          '<div class="simple_popup_service_calc_scrollbar_size"></div>' + 
        '</div>'
      );
      
      console.log ('simple_popup_service init');
    }
    
    this.val.is_init = true;
  }
  
  //コンテナのリサイズ
  
  //コンテナスペースのリサイズ
  , resize: function () {
    //コンテナのオブジェクト
    var container_obj = this.popup_container_obj();
    //ボックス部分のオブジェクト
    var box_obj = this.popup_box_obj();
    //スクロール部分のオブジェクト
    var scroll_obj = this.popup_scroll_obj();
    
    //スクロールバーの横幅
    var scrollbar_size = this.get_scrollbar_size();
    
    //内側の大きさをはかるためコンテナをリセット
    
    //これをしないと圧縮された状態の横幅になる
    container_obj.css('left', '0px');
    container_obj.css('top', '0px');
    container_obj.css('width', 'auto');
    container_obj.css('height', 'auto');
    
    scroll_obj.css('width', 'auto');
    scroll_obj.css('height', 'auto');
    
    //スクロールバーを含まないウインドウのサイズ
    // var win_h = $(window).innerHeight();
    // var win_w = $(window).innerWidth();
    var win_h = this.popup_background_obj().innerHeight();
    //バックグラウンドには常に横のスクロールバーを表示するのでその分を引く
    var win_w = this.popup_background_obj().innerWidth() - scrollbar_size;
    
    //コンテナのwidth,heightをautoにしたときのコンテナのボーダーとパディングを含めたサイズ
    var container_h = container_obj.outerHeight();
    var container_w = container_obj.outerWidth();

    //ウインドウとコンテナの間のパディング
    var win_padding = 22;
    
    //幅の上限
    var w_limit = win_w - (win_padding * 2);
    var h_limit = win_h - (win_padding * 2);
    
    //コンテナサイズ
    var width = container_w;
    var height = container_h;
    
    //高さが上限をオーバーしているか確認
    var height_over = (h_limit < height);
    
    //高さが上限をオーバーしている場合はスクロールバーが表示されるので横幅を広げる
    if (height_over) width += scrollbar_size;
    
    //上限で切り取る
    if (h_limit < height) height = h_limit;
    if (w_limit < width) width = w_limit;
    
    //コンテナのサイズの指定
    container_obj.css('width', width + 'px');
    //上限に達していない場合はautoにすることで、DOMが長くなっても伸びる動きになる
    //伸びすぎた場合はバックグラウンドのスクロールバーで補完されるので操作不能にはならない
    container_obj.css('height', height_over ? height + 'px' : 'auto');
    
    //位置の指定
    var left = (win_w / 2) - (width / 2);
    var top = (win_h / 2) - (height / 2);

    container_obj.css('left', left + 'px');
    container_obj.css('top', top + 'px');

    //ボックスのボーダーとパディングの幅
    var box_buffer_h = box_obj.outerHeight() - box_obj.height();
    var box_buffer_w = box_obj.outerWidth() - box_obj.width();
    
    //スクロール部分のサイズの指定
    //コンテナサイズからボックスのボーダーとパディングの幅を引く
    scroll_obj.css('width', (width - box_buffer_w) + 'px');
    scroll_obj.css('height', height_over ? (height - box_buffer_h) + 'px' : 'auto');
  }
  
  //オープン、クローズ
  
  //ポップアップのオープン
  , open: function (option) {
    if (this.conf.use_fancybox) {
      console.log('fancybox test open');
      $.fancybox(option);
      return;
    }

    this.check_init();

    //開いている場合はいったん閉じる
    if (this.val.is_open) {
      this.suspend();
    }

    this.val.is_open = true;

    if (typeof(option) == 'undefined') option = {};

    this.val.option = option;

    this.val.now_opening = true;

    var self = this;

    var speed = this.conf.default_open_speed;
    if ('openSpeed' in this.val.option) speed = this.val.option.openSpeed;

    //ターゲットスペースの直後に戻すときのために目印を追加
    this.popup_space_obj().after('<div id="' + this.id.keep + '" style="display: none;"></div>');

    //ターゲットスペースをスクロールバー部分のオブジェクトに追加
    this.popup_scroll_obj().append(this.popup_space_obj());

    //ターゲットスペースのCSSのdisplayを保管
    this.val.space_display = this.popup_space_obj().css('display');

    //ターゲットスペースがdisplay:noneの可能性があるので表示させる
    this.popup_space_obj().show();

    //背景はすぐに表示
    this.popup_background_obj().show();

    this.popup_container_obj().fadeIn(speed, function () {
      if (self.val.now_opening) {
        //suspendしたときには動作させない
        
        self.val.now_opening = false;
        
        //コールバック
        if ('afterShow' in self.val.option) {
          
          self.val.option.afterShow();
          
        }
      }
    });
    
    //windowのスクロールバーをなくす
    $('html').addClass('simple_popup_service_html');

    self.resize();
  }
  
  //ポップアップのクローズ
  , close: function () {
    if (this.conf.use_fancybox) {
      console.log('fancybox test close');
      $.fancybox.close();
      return;
    }
    
    var self = this;
    
    //オープンしていない場合は中断
    if ( ! this.val.is_open) return;
    
    if (this.val.now_closing) {
      //閉じている途中の場合はすぐに閉じる
      this.suspend();
      return;
    }
    
    if (this.val.now_opening) {
      //開いている途中の場合はすぐに閉じる
      this.suspend();
      return;
    }
    
    this.val.now_closing = true;
    
    var speed = this.conf.default_close_speed;
    if ('closeSpeed' in this.val.option) speed = this.val.option.closeSpeed;
    
    this.popup_background_obj().fadeOut(speed);
    this.popup_container_obj().fadeOut(speed, function () {
      if (self.val.now_closing) {
        //suspendしたときには動作させない
        
        self.val.now_closing = false;
        
        self.end_common();
      }
    });
  }
  
  //ポップアップをすぐに閉じる
  , suspend: function () {
    //fadeInを止めるとコールバックが動くのでフラグで止める
    this.val.now_opening = false;
    this.val.now_closing = false;
    
    //fadeInが動いている場合は止める
    //（アニメーションを終了までスキップ、待機状態のアニメーションは破棄）
    this.popup_background_obj().stop(true, true);
    this.popup_container_obj().stop(true, true);
    
    this.popup_background_obj().hide();
    this.popup_container_obj().hide();
    
    this.end_common();
  }
  
  //ポップアップを閉じるときの共通処理
  , end_common: function () {
    
    //コールバック
    if ('afterClose' in this.val.option) {
      this.val.option.afterClose();
    }
    
    //windowのスクロールバーを戻す
    $('html').removeClass('simple_popup_service_html');
    
    //ターゲットの位置を目印の位置に戻す
    this.popup_keep_obj().after(this.popup_space_obj());
    
    //ターゲットのCSSのdisplayを戻す
    this.popup_space_obj().css('display', this.val.space_display);
    
    //目印を削除
    this.popup_keep_obj().remove();
    
    this.val.is_open = false;
  }
  
  //セットアップ
  
  //オープンするようにセットアップ
  , setup_open: function (base, option) {
    new this.setup_open_class(base, option);
  }
  //オープンするようにセットアップするためのクラス
  , setup_open_class: function (base, option) {
    base.each (function () {
      var obj = $(this);

      obj.click(function () {
        var href = $(this).attr('href');
        option.href = href;
        simple_popup_service.open(option);
      });
    });
  }
  
  //イベント
  
  //コンテナをクリックしたとき
  , onclick_container: function (event) {
    //親要素のイベントを止める
    event.stopPropagation();
  }
  
  //その他の関数
  
  //スクロールバーの横幅取得
  , get_scrollbar_size: function () {
    //100vw（ビューポートの幅） - １００％ = スクロールバーのサイズ
    var obj = $('.simple_popup_service_calc_scrollbar_size');
    
    var width = obj.css('width');
    
    var size =  parseInt(width.replace('px', ''));
    
    return size;
  }
  
};

window.simple_popup_service = simple_popup_service;
